import apiUrl from '../baseUrls/functions';
import AxiosService from '../axiosConfig/AxiosService';

export default new class TypeMaintenanceService {

    get = (callback, queryParams) => AxiosService.get(apiUrl('/api/crud/type-maintenance/get'), callback, queryParams);
    getById = (id, callback) => AxiosService.get(apiUrl(`/api/crud/type-maintenance/get/${id}`), callback);
    add = (data, callback) => AxiosService.post(apiUrl('/api/crud/type-maintenance/add'), data, callback);
    update = (data, callback) => AxiosService.put(apiUrl('/api/crud/type-maintenance/update'), data, callback);
    delete = (id, callback) => AxiosService.delete(apiUrl(`/api/crud/type-maintenance/delete/${id}`), callback);
   

}